/** Format a row count compactly: 1234 -> "1.2K", 25320156 -> "25M". */
export function formatRowCount(count: number): string {
  if (count >= 1_000_000) {
    const millions = count / 1_000_000;
    return millions < 10 ? `${millions.toFixed(1)}M` : `${Math.round(millions)}M`;
  }
  if (count >= 1_000) {
    const thousands = count / 1_000;
    return thousands < 10 ? `${thousands.toFixed(1)}K` : `${Math.round(thousands)}K`;
  }
  return String(count);
}
